'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var reactRouterDom = require('react-router-dom');
var styled = require('styled-components');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const Wrapper = styled__default["default"].div.withConfig({
  componentId: "sc-17p8bs6-0"
})(["display:flex;align-items:center;flex-direction:column;text-align:center;gap:1.5rem;margin-bottom:2.5rem;padding:0 24px;"]);
const ShipmentWrapper = styled__default["default"].div.withConfig({
  componentId: "sc-17p8bs6-1"
})(["display:flex;align-items:center;flex-direction:column;gap:1rem;width:100%;text-align:center;"]);
const ShipmentHeader = styled__default["default"].div.withConfig({
  componentId: "sc-17p8bs6-2"
})(["display:flex;flex-direction:column;align-items:center;gap:0.5rem;"]);
const ShipmentActionsWrapper = styled__default["default"].ul.withConfig({
  componentId: "sc-17p8bs6-3"
})(["margin:0;padding:0;display:flex;justify-content:center;flex-wrap:wrap;list-style:none;"]);
const ShipmentAction = styled__default["default"].li.withConfig({
  componentId: "sc-17p8bs6-4"
})(["margin:0;:before{content:'\u2022';font-size:0.5rem;margin:0 0.5rem;}:first-child:before{content:'';margin:0;}@media screen and (max-width:768px){width:100%;margin:0.25rem auto;:before{content:'';margin:0;}}"]);
const ShipmentItems = styled__default["default"].div.withConfig({
  componentId: "sc-17p8bs6-5"
})(["display:flex;flex-direction:column;align-items:center;gap:0.5rem;width:100%;"]);
const SpinnerContainer = styled__default["default"].span.withConfig({
  componentId: "sc-17p8bs6-6"
})(["margin:0 0.5rem;"]);
const StyledLink = styled__default["default"](reactRouterDom.Link).withConfig({
  componentId: "sc-17p8bs6-7"
})(["", " ", " @media (hover:hover){&:hover{", " ", "}}"], _ref => {
  let {
    theme
  } = _ref;
  return theme.linksNoneDefault;
}, _ref2 => {
  var _theme$bodytextDefaul;
  let {
    theme
  } = _ref2;
  return styled.css(["color:", ";"], (_theme$bodytextDefaul = theme.bodytextDefaultNone) === null || _theme$bodytextDefaul === void 0 ? void 0 : _theme$bodytextDefaul.color);
}, _ref3 => {
  let {
    theme
  } = _ref3;
  return theme.linksNoneHover;
}, _ref4 => {
  var _theme$bodytextDefaul2;
  let {
    theme
  } = _ref4;
  return styled.css(["color:", ";"], (_theme$bodytextDefaul2 = theme.bodytextDefaultNone) === null || _theme$bodytextDefaul2 === void 0 ? void 0 : _theme$bodytextDefaul2.color);
});

exports.ShipmentAction = ShipmentAction;
exports.ShipmentActionsWrapper = ShipmentActionsWrapper;
exports.ShipmentHeader = ShipmentHeader;
exports.ShipmentItems = ShipmentItems;
exports.ShipmentWrapper = ShipmentWrapper;
exports.SpinnerContainer = SpinnerContainer;
exports.StyledLink = StyledLink;
exports.Wrapper = Wrapper;
